// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ceb1a079","239":"21946ec8","455":"0ded78bb","885":"6824000a"}[chunkId] + ".chunk.js";
};